import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PublicHeader } from "@/components/PublicChrome";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { takePending } from "@/components/SignupSheet";

const NEXT_KEY = "archijo-next";
const PROD_HOSTS = ["archijo.com", "www.archijo.com"];
// REQ-796: page an expired email link was meant to open; used after the next login (magic link or Google), never the home page.
const safeNext = (p) => typeof p === "string" && /^\/app(\/|\?|$)/.test(p) && !p.includes("//") && !p.includes("\\");
export const keepNext = (path) => {
  if (safeNext(path)) localStorage.setItem(NEXT_KEY, JSON.stringify({ path, at: Date.now() }));
};
const takeNext = () => {
  try {
    const n = JSON.parse(localStorage.getItem(NEXT_KEY) || "null");
    localStorage.removeItem(NEXT_KEY);
    return n && Date.now() - n.at < 86400000 && safeNext(n.path) ? n.path : null;
  } catch {
    return null;
  }
};
export const landingFor = () => takeNext() || "/app";  // every login lands on Parcours unless a valid ?next= was kept

// Return from Google: #session_id=... (Emergent) or ?ok=1 (own OAuth client, cookie already set).
export default function AuthGoogle() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = new URLSearchParams(window.location.hash.slice(1));
    const qs = new URLSearchParams(window.location.search);
    const sid = hash.get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    (async () => {
      try {
        if (sid && !PROD_HOSTS.includes(window.location.hostname)) await api.post("/auth/google", { session_id: sid });
        else if (qs.get("ok") !== "1") throw new Error("google");
        const pending = takePending();
        await api.post("/me/claim", { radar_id: qs.get("radar") || pending?.radar_id || null, attribution: pending?.attribution || null, terms: !!pending?.terms });
        const u = await refresh();
        navigate(landingFor(u), { replace: true });
      } catch {
        setFailed(true);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-dvh bg-bg">
      <PublicHeader onLogin={() => {}} />
      <main className="mx-auto max-w-[440px] px-5 pt-16">
        <p className="text-[15px] text-muted" data-testid={failed ? "google-failed" : "google-checking"}>
          {failed ? "La connexion avec Google est indisponible pour le moment. Continue avec ton email." : "Connexion en cours..."}
        </p>
        {failed && (
          <a href="/?login=1" className="mt-4 inline-flex h-12 items-center rounded-full bg-ink px-6 text-[15px] font-medium text-bg" data-testid="google-failed-email-btn">
            Continuer avec mon email
          </a>
        )}
      </main>
    </div>
  );
}
